import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux'
import { CircularProgress } from 'material-ui';
import R from 'ramda';
import DiffReportContent from './diffing/content';

import { getDiffReport } from '../../../stores/contracting-reports/actions';

const propTypes = {
  availDocs: PropTypes.array,
  generatingReport: PropTypes.bool,
  diffMetaData: PropTypes.object,
  rawDiffData: PropTypes.array,
  getDiffReport: PropTypes.func,
  params: PropTypes.object,
  goBack: PropTypes.func,
  ratesSummary: PropTypes.object,
};

class DiffReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const collection = this.props.params.collection;
    const baseId = this.props.params.baseId;
    const compareId = this.props.params.compareId;
    this.props.getDiffReport(`${collection}:${compareId}:${baseId}`);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.params !== this.props.params) {
      const collection = nextProps.params.collection;
      const baseId = nextProps.params.baseId;
      const compareId = nextProps.params.compareId;
      this.props.getDiffReport(`${collection}:${compareId}:${baseId}`);
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { rawDiffData, diffMetaData, generatingReport, availDocs, ratesSummary } = this.props;
    if (generatingReport) {
      return (
        <div style={{ paddingTop: '150px', textAlign: 'center' }}>
          <CircularProgress size={100} thickness={7} />
          <div style={{ marginTop: '16px' }}> We are working hard to generate the report, thanks for your patience!</div>
        </div>
      )
    }
    return (
      <DiffReportContent
        diffMetaData={diffMetaData}
        rawDiffData={rawDiffData}
        availDocs={availDocs}
        ratesSummary={ratesSummary}
      />
    );
  }
}

const mapStateToProps = ({ contractingReports }) => ({
  generatingReport: contractingReports.get('generatingReport'),
  ...contractingReports.get('diff'),
});

const mapDispatchToProps = ({ getDiffReport, goBack });
DiffReportContainer.propTypes = propTypes;
DiffReportContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(DiffReportContainer);




// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diff-report-page.jsx